export default class ChangePasswordRequestDTO {

    public oldPassword = "";

    public password = "";

    public confirmPassword = "";

}